import type React from "react";
import {Tooltip} from "@mui/material";
import type {ContractDocument} from "../contractExplorerTypes.ts";
import type {Fact} from "../contractExplorerFormat.ts";
import {formatValue} from "../contractExplorerFormat.ts";
import {SourceCite} from "./SourceCite.tsx";

type Props = {
    fact: Fact | undefined;
    documents: Record<string, ContractDocument>;
    /** How to show the value; `formatValue` by default. */
    format?: (value: unknown) => string;
};

/** An extracted value with its citation, marked when it changed in this version. */
export const FactValue: React.FC<Props> = ({fact, documents, format = formatValue}) => {
    if (!fact) return <span className="ci-dash">—</span>;
    return (
        <span>
            {format(fact.value)}
            {fact.change === 'changed' && (
                <Tooltip arrow title={`Was ${format(fact.previous)} in the version before`}>
                    <span className="ci-change">changed</span>
                </Tooltip>
            )}
            {fact.change === 'added' && <span className="ci-change">new</span>}
            <SourceCite documentId={fact.documentId} documents={documents}/>
        </span>
    );
};
